import { Route, Routes } from "react-router-dom"
import AddUser from "./AddUser"
import UsersList from "./UsersList"

export type UsersProps = {}

const Users: React.FC<UsersProps> = () => {
  return (
    <Routes>
      <Route path="/add" element={<AddUser />} />
      <Route path="/" element={<UsersList />} />
    </Routes>
  )
}

export default Users
